import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Link } from "react-router-dom";
import Button from "../../components/Common/Button/Button";
import Input from "../../components/Common/Input/Input";
import { validations } from "../../utils/validations";
import { useDispatch } from "react-redux";
import classes from "./ChangePasswordPage.module.scss";
import { setErrorHandler } from "../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../utils/errorTypes";
import { resetPasswordActionHandler } from "../../store/actions/actionHandlers/commonActionHandler";
import { FormattedMessage, injectIntl } from "react-intl";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

export const changePwdSchema = yup.object().shape({
  currentPassword: yup.string().trim(),
  newPassword: yup.string().trim(),
  confirmNewPassword: yup.string().trim(),
});

const ChangePasswordPage = ({ intl }) => {
  const dispatch = useDispatch();
  const { WARN } = errorTypes;
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(changePwdSchema),
  });
  const {
    handleSubmit,
    watch,
    reset,
    formState: { errors, isValid },
  } = methods;
  // useEffect(() => {
  //   dispatch(resetPasswordActionHandler("currentPassword","NewPassword"))
  // }, [dispatch])

  const onSubmit = (data) => {
    var passwordRegex =
      /^(?!.* )(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#%$&'()*+,-./:;<=>?@[\]^_`{|}~])(?=.{8,30})/;
    var res = passwordRegex.test(data.newPassword);

    if (!res) {
      dispatch(
        setErrorHandler(
          WARN,
          "Use 8 or more characters with a mix of letters (upper and lower), numbers & symbols"
        )
      );
    } else if (data.newPassword.length > 30) {
      dispatch(setErrorHandler(WARN, "Maximum 30 characters allowed"));
    } else if (data.newPassword !== data.confirmNewPassword) {
      dispatch(
        setErrorHandler(
          WARN,
          "New password and confirm password should be same"
        )
      );
    } else {
      dispatch(
        resetPasswordActionHandler(
          data.currentPassword,
          data.confirmNewPassword
        )
      );
    }
    reset();
  };
  const resetPwd = watch(
    ["currentPassword", "newPassword", "confirmNewPassword"],
    false
  );
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={classes.resetFormMainDiv}>
          <div className={classes.resetPwdForm}>
            <div className={classes.resetPwdForm__labelInputBox}>
              <Input
                label={<FormattedMessage id="MY_PROFILE_CURR_PWD__TEXT" />}
                name="currentPassword"
                placeholder={intl.formatMessage({
                  id: `MY_PROFILE_CURR_PWD__TEXT`,
                })}
                labelColor="light"
                type="password"
                error={errors.Username?.message}
                validations={validations(true, "Please enter current Password")}
                // noPasswordIcon
                onKeyDown={(e) => {
                  if (e.keyCode === 32) {e.preventDefault()};
                }}
              />
            </div>
            <div className={classes.resetPwdForm__labelInputBox}>
              <Input
                label={<FormattedMessage id="MY_PROFILE_NEW_PWD__TEXT" />}
                name="newPassword"
                placeholder={intl.formatMessage({
                  id: `MY_PROFILE_NEW_PWD__TEXT`,
                })}
                labelColor="light"
                type="password"
                error={errors.newPassword?.message}
                validations={validations(true, "Please enter new Password")}
                // noPasswordIcon
                onKeyDown={(e) => {
                  if (e.keyCode === 32) {e.preventDefault()};
                }}
              />
            </div>
            <div className={classes.resetPwdForm__labelInputBox}>
              <Input
                label={<FormattedMessage id="MY_PROFILE_RENEW_PWD__TEXT" />}
                name="confirmNewPassword"
                placeholder={intl.formatMessage({
                  id: `MY_PROFILE_RENEW_PWD__TEXT`,
                })}
                labelColor="light"
                type="password"
                error={errors.confirmNewPassword?.message}
                validations={validations(true, "Please Re-enter new Password")}
                // noPasswordIcon
                onKeyDown={(e) => {
                  if (e.keyCode === 32) {e.preventDefault()};
                }}
              />
            </div>
            <div className={classes.resetPwdForm__buttons}>
              <Link
                to={`/${localStorage.getItem(
                  "tenantName"
                )}/userProfile/myProfile`}
              >
                <FormattedMessage id="CANCEL_TEXT" />
              </Link>
              <Button
                label={<FormattedMessage id="MY_PROFILE_CHANGE_PWD__TEXT" />}
                light
                disabled={!(resetPwd[0] && resetPwd[1] && resetPwd[2])}
                borderColor={"#707070"}
                width={"18.6"}
                height={"3.6"}
                borderRadius={"20"}
                type="submit"
                noPasswordIcon
              />
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default injectIntl(ChangePasswordPage);
